import React from 'react';
import { Stack, Typography } from "@mui/material";
import { FrontHand } from '@mui/icons-material';
import type { PartRendererProps } from './types';

const SuspendedPart: React.FC<PartRendererProps> = () => (
    <Stack direction="row" gap={2} sx={{ fontStyle: 'italic', fontSize: '0.8rem', color: 'text.secondary' }}>
        <FrontHand />
        <Typography>Interação suspendida</Typography>
    </Stack>
);

export default SuspendedPart;
